import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import ptBR from 'vuetify/lib/locale/pt'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { ptBR },
    current: 'ptBR',
  },
  theme: {
    themes: {
      light: {
        primary: "#1887B4",
        secondary: "#673ab7",
        accent: "#3f51b5",
        error: "#f44336",
        warning: "#ffc107",
        info: "#00bcd4",
        success: "#4caf50"
      }
    },
    options: {
      customProperties: true,
    }
  }
});
 